"use client"

import { Sun, Moon } from "lucide-react"
import { useTheme } from "@/components/ThemeProvider"

interface ThemeToggleProps {
  className?: string
  style?: React.CSSProperties
}

export function ThemeToggle({ className, style }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className={`rounded-lg p-1.5 transition-colors ${className ?? ""}`}
      style={{ color: "var(--ljs-text-dim)", ...style }}
      aria-label={theme === "dark" ? "Passer au thème clair" : "Passer au thème sombre"}
      title={theme === "dark" ? "Thème clair" : "Thème sombre"}
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  )
}
